<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title class='text-xs-left'>
            <div>
              <h3>JWT</h3>
              <div>Show JWT Content</div>
            </div>
          </v-card-title>
          <v-card-text class='text-xs-left'>
            <pre>{{jwtDecoded}}</pre>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-divider inset></v-divider>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title class='text-xs-left'>
            <div>
              <h3>VUEX</h3>
              <div>Show VUEX Content<br>(Excluding the token -- the token is too long and clutter the display)</div>
            </div>
          </v-card-title>
          <v-card-text class='text-xs-left'>
            {{vuexContent}}
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import jwtDecode from 'jwt-decode'
  export default {
    computed: {
      jwtDecoded: () => {
        const token= JSON.parse(localStorage.getItem('vuex')).token
        if (!token) {
          return 'No token set yet'
        } else {
          return jwtDecode(token)
        }
      },
      vuexContent: () => {
        const jsons = JSON.parse(localStorage.getItem('vuex'))
        return JSON.stringify(jsons, (key, value) => {
          if (key != 'token') return value
        }, 2)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/DeveloperTesting/JWT.vue